import { render, staticRenderFns } from "./GlueEditComp.vue?vue&type=template&id=1ba97588&scoped=true&"
import script from "./GlueEditComp.vue?vue&type=script&lang=ts&"
export * from "./GlueEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./GlueEditComp.vue?vue&type=style&index=0&id=1ba97588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba97588",
  null
  
)

export default component.exports